import { render } from "./BottomNav.vue?vue&type=template&id=d1a1537a&scoped=true"
import script from "./BottomNav.vue?vue&type=script&lang=js"
export * from "./BottomNav.vue?vue&type=script&lang=js"

import "./BottomNav.vue?vue&type=style&index=0&id=d1a1537a&scoped=true&lang=css"

import exportComponent from "D:\\WWW\\partner\\template\\obp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1a1537a"]])

export default __exports__